















import { Component, Vue } from 'vue-property-decorator';

@Component({
    props: {
        name: {
            type: String,
            default: '',
        },
        id: {
            type: String,
        },
        active: {
            type: Boolean,
            default: false,
        },
    },
})
export default class Toggle extends Vue {
    constructor() {
        super();
    }
}
